<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Starter component
 */
export default {
  page: {
    title: "Home",
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Client home page",
    };
  }
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
  </Layout>
</template>
